// extracted by mini-css-extract-plugin
module.exports = {"rossumPage":"DetailPage_rossumPage__1rqCh","detailPage":"DetailPage_detailPage__6aQb8"};